import { render, staticRenderFns } from "./textInput.vue?vue&type=template&id=02c40bfa&scoped=true&lang=pug&"
import script from "./textInput.vue?vue&type=script&lang=js&"
export * from "./textInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c40bfa",
  null
  
)

export default component.exports